

(function () {
    'use strict';

    angular
        .module('index.authorsEditor', [])

        .directive('indexMenu', function () {
            var directive = {
                restrict: 'A',

                /* @ngInject */
                controller: ["$rootScope", "$window", "$cookies", "$element", function ($rootScope, $window, $cookies, $element) {

                    var ctrl = this;

                    ctrl.$onInit = function () {

                        

                    };
                    
                }],
                controllerAs: 'indexMenuCtrl'
            };

            return directive;
        })







})();

